/* import __COLOCATED_TEMPLATE__ from './lsg-dialog.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

/**
 * The height types of the lsg-dialog.
 *
 * @type {Object}
 */
export const LSG_DIALOG_HEIGHT_TYPE = {
  HEIGHT_300_px: '300_px',
  HEIGHT_MAX_400_PX: 'max_400_px', // max height
  HEIGHT_600_PX: '600_px', // exact height
  HEIGHT_MAX_800_PX: 'max_800_px', // max height
  HEIGHT_MAX: 'height-max', //dialog will stretch to max allowed
};

/**
 * The width types of the lsg-dialog.
 *
 * @type {Object}
 */
export const LSG_DIALOG_WIDTH_TYPE = {
  WIDTH_400_PX: '400_px',
  WIDTH_500_PX: '500_px',
  WIDTH_600_PX: '600_px',
  WIDTH_MAX_WIDTH_800_PX: '800_px',
};

class LsgDialogComponent extends Component {
  get opacity() {
    return this.args.opacity ?? 0.54;
  }

  get isShowHeaderBorder() {
    return this.args.isShowHeaderBorder ?? true;
  }

  get heightType() {
    return this.args.heightType || LSG_DIALOG_HEIGHT_TYPE.HEIGHT_300_px;
  }

  get widthType() {
    return this.args.widthType || LSG_DIALOG_WIDTH_TYPE.WIDTH_400_PX;
  }

  get is400MaxHeightType() {
    return this.heightType === LSG_DIALOG_HEIGHT_TYPE.HEIGHT_MAX_400_PX;
  }

  get is600HeightType() {
    return this.heightType === LSG_DIALOG_HEIGHT_TYPE.HEIGHT_600_PX;
  }

  get is800MaxHeightType() {
    return this.heightType === LSG_DIALOG_HEIGHT_TYPE.HEIGHT_MAX_800_PX;
  }

  get isHeightTypeMax() {
    return this.heightType === LSG_DIALOG_HEIGHT_TYPE.HEIGHT_MAX;
  }

  get is500MaxWidth() {
    return this.widthType === LSG_DIALOG_WIDTH_TYPE.WIDTH_500_PX;
  }

  get is600MaxWidth() {
    return this.widthType === LSG_DIALOG_WIDTH_TYPE.WIDTH_600_PX;
  }

  get is800MaxWidth() {
    return this.widthType === LSG_DIALOG_WIDTH_TYPE.WIDTH_MAX_WIDTH_800_PX;
  }

  get classNames() {
    return clsx(
      this.args.class,
      'LSG-c-dialog',
      this.args.isAllowOverflow && 'LSG-c-dialog--allow-overflow',
      this.args.isLoading && 'SH-u-is-loading',
      this.args.isHideFooter && 'is-hide-footer',
      this.args.isFixedFooter && 'is-fixed-footer',
      this.isShowHeaderBorder && 'show-header-border',
      this.is400MaxHeightType && 'height-type-400-max-height',
      this.is600HeightType && 'height-type-600',
      this.is800MaxHeightType && 'height-type-800-max-height',
      this.is500MaxWidth && 'width-type-500-max-width',
      this.is600MaxWidth && 'width-type-600-max-width',
      this.is800MaxWidth && 'width-type-800-max-width',
      this.isHeightTypeMax && 'height-type-max',
    );
  }
}

export default LsgDialogComponent;
